export const kopecksToBonusAmount = (amount: number | null | undefined) =>
  Math.max(0, (amount || 0) / 100)

export const formatBonusAmount = (amount: number) =>
  Number.isInteger(amount) ? String(amount) : amount.toFixed(2).replace(/\.?0+$/, '')
